import React from 'react';

export const NOT_TRANSLATED_PLACEHOLDER = '<Not translated>';

export const isMissingTranslatedMetadataValue = (value: unknown): boolean => {
  const trimmed = String(value ?? '').trim();
  return !trimmed || trimmed.toLowerCase() === NOT_TRANSLATED_PLACEHOLDER.toLowerCase();
};

export const normalizeTranslatedMetadataValue = (value: unknown): string => (
  isMissingTranslatedMetadataValue(value) ? '' : String(value ?? '')
);

export const stripMetadataHtml = (value: unknown): string => (
  String(value ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
);

export const summarizeTranslatedMetadataValue = (value: unknown, maxLength = 64): string => {
  const text = stripMetadataHtml(value);
  return text.length > maxLength ? `${text.slice(0, Math.max(0, maxLength - 3))}...` : text;
};

export const NotTranslatedPlaceholder: React.FC<{
  className?: string;
}> = ({ className }) => (
  <span className={['not-translated-placeholder', className].filter(Boolean).join(' ')}>
    {NOT_TRANSLATED_PLACEHOLDER}
  </span>
);
